// extracted by mini-css-extract-plugin
export default {"wrapper":"Auth_wrapper__c3UOJ","content":"Auth_content__K1lpw"};